import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff864398"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "アイコンメニュー設定一覧")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_settingName" }, "設定名"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_settingTarget" }, "設定対象"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_settingTargetDetail" }, "設定対象詳細"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_ReflectionDate" }, "反映日"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_scheduleDate" }, "反映予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_datail" }, "詳細")
  ])
], -1))
const _hoisted_11 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { style: {"text-align":"left","padding-left":"10px"} }
const _hoisted_14 = { style: {"text-align":"left","padding-left":"10px"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "form-inline flex-container" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconMenuKanriList, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.iconMenuKanriId
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          type: "checkbox",
                          class: "form-check-input",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event)
                        }, null, 8, _hoisted_12), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.settingName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.settingTargetKbn), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(item.settingTargetName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.reflectionDate), 1),
                      _createElementVNode("td", null, _toDisplayString(item.scheduledDate), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          onClick: ($event: any) => (_ctx.showDetail(item.iconMenuKanriId))
                        }, " 詳細 ", 8, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, " 削除 ")
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnClear",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                  }, " クリア "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args)))
                  }, " 新規登録 ")
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}